import { render, staticRenderFns } from "./ChatImageViewer.vue?vue&type=template&id=21320d74&scoped=true"
import script from "./ChatImageViewer.vue?vue&type=script&lang=js"
export * from "./ChatImageViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21320d74",
  null
  
)

export default component.exports